import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import help from '@/common/help';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: routes
});
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

router.beforeEach((to, from, next) => {
  // const title = to.meta && to.meta.title
  // if (title) {
  //   document.title = title
  // }

  if (to.matched.some(record => record.meta.requireAuth)) { // 判断该路由是否需要登录权限
    if (help.getToken()) { // 判断当前的token是否存在 ； 登录存入的token
      next();
    } else {
      next({
        name: 'wx_login',
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});

export {
  router
};
